<template>
    <div class="position-relative" v-click-outside="closeDropDown">
        <button
            type="button"
            class="ck ck-button toggle-button"
            @click="toggleList"
            :class="{ 'ck-on': open, 'ck-off': !open }"
        >
            <img src="/static/images/template-icon.svg" alt="Template Icon" class="mr-1 template-icon" />
            <font-awesome-icon class="ml-1" :icon="['fas', 'chevron-down']" />
        </button>
        <ul v-if="open" class="position-absolute template-list">
            <li
                v-for="template in templates"
                :key="template.title"
                class="d-flex align-items-center"
                @click="insertHtml(template.html)"
            >
                <div class="d-flex ml-4 flex-column">
                    <h6 class="font-bold ml-0">{{ template.title }}</h6>
                    <span>{{ template.description }}</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        templates: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            open: false,
        };
    },
    methods: {
        toggleList() {
            this.open = !this.open;
        },
        closeDropDown() {
            this.open = false;
        },
        insertHtml(html) {
            this.closeDropDown();
            this.$emit('insert-html', html);
        },
    },
};
</script>

<style lang="scss" scoped>
.template-icon {
    width: 20px;
    height: 20px;
}
.toggle-button {
    border: none;
    background: transparent;
}
.template-list {
    background-color: white;
    border: 1px solid #dddddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    z-index: 10;
    max-width: 400px;
    max-height: 250px;
    overflow: auto;

    li {
        border-bottom: 1px solid #dddddd;
        cursor: pointer;
        padding: 10px;
        text-align: left;

        &:hover {
            background-color: #f7f7f7;
        }
    }
}
</style>